import { get, BaseUrl } from './api';

export const getCustomerUserAccess = async () => {
    return await get(`api/CustomerUser/AllProductFeatures`, null,
        BaseUrl.Centerpoint);
}